'strict mode';

var _    = require('underscore');
require('./request-animation-pollyfill');

/**
 * rgbSegmentToHex
 * converts an rgb segment to hex
 * @param  {string} x rgb segment value
 * @return {string}   hex segment value
 */
var rgbSegmentToHex = (function rgbSegmentToHexClosure() {
  var hexDigits = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f']; 
  
  return function rgbSegmentToHex(x) {
    return isNaN(x) ? '00' : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
  };
})();

module.exports = {

  /**
   * Checks an image to see if its area is valid
   * 
   * @param  {string}     imgSrc      url or base64 string
   * @param  {int}        maxArea     max area of image
   * @param  {Function}   callback    callback which will be supplide with a boolean success arg 
   */
  validateImageArea: function validateImageArea(imgSrc, maxArea, callback) {
    var img = new Image();

    img.onload = function () {
      callback((this.width * this.height <= maxArea));
    };

    img.src = imgSrc;
  },

  /**
   * Capitalize first letter of string
   * 
   * @param  {string} string    string to capitalize
   * @return {string}           capitalize string
   */
  capitalizeFirst: function capitalizeFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

	/**
	 * cloneDataObject
	 * clone basic data structures
	 * 
   * - this will clone methods as well
   * - this has better perf than `JSON.parse(JSON.stringify(obj))`
   *   https://jsperf.com/deep-copy-vs-json-stringify-json-parse
   * 
	 * @param  {object} o  object to cloine
	 * @return {object}      cloned object
	 */
	cloneDataObject: function cloneDataObject(o) {
	  var copy = o,k;

	  if (o && typeof o === 'object') {
	    copy = Object.prototype.toString.call(o) === '[object Array]' ? [] : {};
	    for (k in o) {
	      copy[k] = cloneDataObject(o[k]);
	    }
	  }

	  return copy;
	},

  /**
   * Generates a random string based on a given length.
   * @param  {number} L Length of expected string.
   * @return {string}
   */
  randomString: function randomstring(L){
    var s = '';
    function randomchar(){
      var n= Math.floor(Math.random()*62);
      if(n<10) { return n; } //1-10 
      if(n<36) { return String.fromCharCode(n+55); } //A-Z 
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) { s+= randomchar(); }
    return s;
  },

  /**
   * Pattern to use window.FileReader().
   * @param  {object}   file     File from the file input.
   * @param  {function} callback Function to be called from the reader.
   */
  fileReader: function fileReader(file, callback) {
    var reader = new window.FileReader();

    reader.onload = function(readerEvt) {
      callback(readerEvt);
    };

    reader.readAsDataURL(file);
  },

  /**
   * Diffs two objects or arrays and gives you the changed data.
   * @param  {object} oldData  Original object.
   * @param  {object} newData  New object.
   * @return {object}      Data that's changed.
   */
  getDiff: function getDiff(oldData, newData) {
    return _.reduce(newData, function diff(changedData, newVal, index) {
      var oldVal;

      if(_.isUndefined(newVal)) { return changedData; }

      oldData = _.isUndefined(oldData) ? {} : oldData;
      oldVal = oldData[index];

      var tempVal;
      if(oldVal !== newVal) {
        if(_.isObject(newData[index]) && !_.isArray(newVal)) {
          tempVal = getDiff.call(this, oldVal, newVal);
          if(!_.isEmpty(tempVal)) {
            changedData[index] = tempVal;
          }
        } else {
          changedData[index] = newVal;
        }
      }

      return changedData;
    }, {}, this);
  },

  //
  /** 
  * rgb2hex
  * Function to convert rgb color to hex format
  * @param  {string}  rgb      rgb color string
  * @param  {boolean} noHash   flag to include hash symbol or not
  * @return {string}           hexidecimal string converted from rgb string
  */
  rgb2hex: (function rgb2hexClosure() {
    var rgbRegEx = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;

    return function rgb2hex(rgb, noHash) {
      var hash = noHash ? '' : '#'; 
      rgb = rgb.match(rgbRegEx);
      return hash + rgbSegmentToHex(rgb[1]) + rgbSegmentToHex(rgb[2]) + rgbSegmentToHex(rgb[3]);
    };
  })(),

  /**
   * Makes a attribute selector
   * @param  {string} attr            attribute name
   * @param  {string} value           value for selector
   * @param  {obj}    options         options for selector
   *    selectorType  default '='     operation used to asses value
   * @return {string}                 full attribute selector
   */
  makeAttributeValueSelector: function makeAttributeValueSelector(attr, value, options) {
    options = _.defaults(options || {}, {
      selectorType: '='
    });

    if(value) {
      return '[' + attr + options.selectorType + '"' + value + '"]';
    }
    else {
      return '[' + attr + ']';
    }
  },

  /**
   * removes a prefix off of every param in the object that has it
   *
   * @param prefix
   * @param obj
   */
  removePrefix: function removePrefix(prefix, obj) {
    return _.reduce(obj, function (newObj, val, oldKey) {
      var newKey = oldKey.replace(prefix, '');
      if(newKey.length) {
        newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
      }
      newObj[newKey] = val;
      return newObj;
    }, {});
  },

  //from https://gist.github.com/joelambert/1002116
  /**
   * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
   * @param {function} fn The callback function
   * @param {int} delay The delay in milliseconds
   */
  requestTimeout: function(fn, delay) {
    var start = new Date().getTime(),
      handle = {};

    function loop() {
      var current = new Date().getTime(),
        delta = current - start;

      if (delta >= delay) {
        fn.call();
      } else {
        handle.value = window.requestAnimationFrame(loop);
      }
    }

    handle.value = window.requestAnimationFrame(loop);
    return handle;
  },

  /**
   * Extracts a query parameter value from a URI.
   * @param {string} uri The URI from which to extract the parameter.
   * @param {string} paramName The name of the query paramater to extract.
   * @return {string} The un-encoded value of the query paramater. underfined
   *     if there is no URI parameter.
   * @private
   */
  extractParamFromUri: function extractParamFromUri(uri, paramName) {
    if (!uri) {
      return null;
    }
    uri = uri.split('#')[0];  // Remove anchor.
    var parts = uri.split('?');  // Check for query params.
    if (parts.length === 1) {
      return null;
    }
    var query = decodeURI(parts[1]);

    // Find url param.
    paramName += '=';
    var params = query.split('&');
    for (var i = 0, param; i < params.length; ++i) {
      param = params[i];
      if (param.indexOf(paramName) === 0) {
        return window.unescape(param.split('=')[1]);
      }
    }
    return null;
  }
};
